import React from 'react';
import { observer } from 'mobx-react-lite';
import { toDateTimeQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditDateTime } from './edit/EditDateTime';
import { ViewDateTime } from './view/ViewDateTime';
export var DateTime = observer(function (_ref) {
  var id = _ref.id,
    questionStore = _ref.questionStore,
    displayMode = _ref.displayMode,
    errorId = _ref.errorId;
  var currentAnswer = toDateTimeQuestionAnswerOrEmpty(questionStore.currentAnswer);
  var showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2;
    return /*#__PURE__*/React.createElement(EditDateTime, {
      id: id,
      errorId: errorId,
      dateValue: currentAnswer.date,
      timeValue: currentAnswer.time,
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      onDateChange: function onDateChange(value) {
        questionStore.setAnswer({
          date: value,
          time: toDateTimeQuestionAnswerOrEmpty(questionStore.currentAnswer).time
        });
      },
      onTimeChange: function onTimeChange(value) {
        questionStore.setAnswer({
          date: toDateTimeQuestionAnswerOrEmpty(questionStore.currentAnswer).date,
          time: value
        });
      },
      label: (_questionStore$formQu2 = questionStore.formQuestion) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.label
    });
  }
  return /*#__PURE__*/React.createElement(ViewDateTime, {
    id: id,
    dateValue: currentAnswer.date,
    timeValue: currentAnswer.time,
    displayMode: displayMode
  });
});